import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { isPreview } from '../../services/env';

const propTypes = {
  meta: PropTypes.object.isRequired,
  noIndex: PropTypes.bool,
};

const Meta = ({ meta, noIndex = false, children }) => (
  <Helmet>
    {meta.title ? <title>{meta.title} - Checkout Page</title> : ''}
    {meta.title ? <meta property="og:title" content={meta.title} /> : ''}
    {meta.title ? <meta name="twitter:title" content={meta.title} /> : ''}

    <link rel="icon" href="https://assets.checkoutpage.com/logo.webp" key="favicon" />

    <link rel="apple-touch-icon" href="https://assets.checkoutpage.com/logo.webp" />

    <link rel="mask-icon" href="https://assets.checkoutpage.com/logo.webp" color="black" />

    {meta.description ? <meta name="twitter:description" content={meta.description} /> : ''}
    {meta.description ? <meta property="og:description" content={meta.description} /> : ''}
    {meta.description ? <meta name="description" content={meta.description} /> : ''}

    {meta.url ? <meta property="og:url" content={meta.url} /> : ''}
    {meta.url ? <meta name="twitter:url" content={meta.url} /> : ''}

    {Object.prototype.hasOwnProperty.call(meta, 'image') ? (
      <meta property="og:image" content={meta.image} />
    ) : (
      ''
    )}

    {/*
      The react-helmet library has trouble with Fragments in development mode because:
      1. Fragments create internal Symbol properties for React's reconciliation
      2. Helmet tries to convert these to strings for processing
      3. JavaScript can't convert Symbols to strings directly
*/}
    {(noIndex || isPreview) && [
      <meta key="robots" name="robots" content="noindex" />,
      <meta key="googlebot" name="googlebot" content="noindex" />,
    ]}

    {children}
  </Helmet>
);

Meta.propTypes = propTypes;
Meta.defaultProps = { noIndex: false };

export default Meta;
